import Icon from '../components/Icon.vue'

Icon.register({
  'poo-storm': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M308 336c9.2 0 15 10 10.4 18l-88 152c-2.2 3.8-6.2 6-10.4 6-7.7 0-13.5-7.2-11.7-14.8l23-97.2h-59.3c-7.3 0-12.9-6.4-11.9-13.6l16-120c0.8-5.9 5.9-10.4 11.9-10.4h68c7.9 0 13.6 7.5 11.6 15.1l-17.3 64.9h57.7zM374.4 224.7c41 3.3 73.6 37.5 73.5 79.3 0 44-36 80-80 80h-30l8.1-14c7.8-13.5 7.8-30.4 0-44s-22.4-22-38.1-22h-16l6.6-24.7c3.6-13.3 0.8-27.2-7.6-38.1-8.4-10.9-21.1-17.2-34.9-17.2h-68c-22 0-40.7 16.4-43.7 38.2l-16 120c0 0.6 0.1 1.2 0 1.8h-48.3c-44 0-80-36-80-80 0-41.8 32.6-76 73.6-79.3-5.9-9.6-9.6-20.6-9.6-32.7 0-35.3 28.7-64 64-64h16c44.2 0 80-35.8 80-80 0-17.4-5.7-33.4-15.1-46.5 4.9-0.8 9.9-1.5 15.1-1.5 53 0 96 43 96 96 0 11.3-2.3 21.9-5.9 32h5.9c35.3 0 64 28.7 64 64 0 12.1-3.7 23.1-9.6 32.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/poo-storm.js
// module id = 1655
// module chunks = 0